<template>
    <base-modal
        hide-footer
        hide-header
        size="lg"
        @close="$emit('closeForm')"
    >
        <div class="col-sm-12 editor-form">
            <h2 class="editor-header">
                {{ roadSignUpdate.id > 0 || roadSigns.length === 1 ? $t('road_sign.edit') : roadSigns && roadSigns.length > 1 ? $t('road_sign.edit_multiple') : $t('road_sign.add_new') }}
            </h2>
            <div class="row">
                <!-- Show open contracts  -->
                <div class="col-12 nopads">
                    <span class="span-title">{{ $t('orders.contract') }}</span>
                    <select
                        id="contract"
                        v-model="roadSignUpdate.contract.id"
                        class="form-select form-select-sm mb-3"
                        :disabled="roadSignUpdate.remove === '1'"
                    >
                        <option :value="null">
                            {{ $t('orders.select_contract') }}
                        </option>
                        <option
                            v-for="option in contracts"
                            :key="option.id"
                            :value="option.id"
                        >
                            {{ option.name }}
                        </option>
                    </select>
                </div>

                <div class="col-12 nopads">
                    <span class="span-title">{{ $t('road_sign.condition') }}</span>
                    <select
                        id="contract"
                        v-model="roadSignUpdate.condition"
                        class="form-select form-select-sm mb-3"
                        :disabled="roadSignUpdate.remove === '1'"
                    >
                        <option :value="null">
                            {{ $t('road_sign.select_condition') }}
                        </option>
                        <option
                            v-for="option in getConditions()"
                            :key="option.value"
                            :value="option.value"
                        >
                            {{ option.name }}
                        </option>
                    </select>
                </div>

                <div class="col-12 nopads mt-2">
                    <input
                        id="checkbox_remove"
                        v-model="roadSignUpdate.remove"
                        type="checkbox"
                        class="form-check-input me-2"
                        value="1"
                    >
                    <label
                        class="form-check-label"
                        for="checkbox_remove"
                    >
                        {{ $t('road_sign.remove') }}
                    </label>
                </div>

                <div class="col-sm-12 button-container">
                    <button
                        class="btn btn-secondary form-button"
                        @click.stop="$emit('closeForm')"
                    >
                        {{ $t('common.cancel') }}
                    </button>
                    <button
                        class="btn btn-success form-button"
                        :disabled="loading"
                        @click.stop="submitMultiple"
                    >
                        {{ $t('common.save') }}
                    </button>
                </div>
            </div>
            <div
                v-if="loading"
                id="loader"
                class="spinner"
            />
        </div>
    </base-modal>
</template>

<script>
import {restApi} from "../mixins/RestApiMixin";
import {attachmentHelper} from "../mixins/AttachmentMixin";
import {workAssignmentHelper} from "../mixins/WorkAssignmentMixin";
import {roadSignHelper} from "@/components/mixins/RoadSignMixin";
import {timeUtils} from "../mixins/TimeUtils";
import BaseModal from "@/components/BaseModal";
import {inject} from "vue";
import {userHelper} from "../mixins/UserMixin.js";

export default {
    name: "RoadSignBulkEditorDialog",
    components: {BaseModal},
    mixins: [workAssignmentHelper, restApi, timeUtils, attachmentHelper, roadSignHelper, userHelper],
    props: {
        roadSigns: null,
        user: {type: Object, default: null},
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function (){
        return{
            roadSignUpdate: this.newRoadSignMultiple(this.roadSign),
            contracts: [],
            loading: false,
        }
    },
    computed: {
        louhiState() {
            const all = this.roadSigns.every(r => r.external_system === 2);
            const none = this.roadSigns.every(r => !r.external_system || r.external_system !== 2);

            if (all) return 'all';
            if (none) return 'none';
            return 'mixed';
        },
        isObserver() {
            return this.user && this.hasObserver(this.user.roles)
        }
    },
    mounted: function() {
        if (this.isObserver && this.louhiState === 'none') {
            this.fetchOpenContracts()
        } else if (this.isObserver && this.louhiState === 'all') {
            this.fetchLouhiContracts()
        }
    },
    methods: {
        newRoadSignMultiple: function (like) {
            return {
                contract: like && like.contract ? like.contract : {id: null},
                condition: like && like.condition ? like.condition : null,
                remove: like && like.remove ? true : undefined,
                ...like
            }
        },
        submitMultiple:function (){
            let newRoadSign = this.setDefaultValues(this.roadSignUpdate)
            if (newRoadSign) {
                this.loading = true
                if(!this.roadSigns) this.fail
                var roadSignIds = []
                this.roadSigns.forEach(function (roadSign) {
                    roadSignIds.push(roadSign.id)
                })
                let params = {}
                if(newRoadSign.remove) {
                    params.remove = 1
                } else {
                    if(newRoadSign.contract) {
                        params.contract = newRoadSign.contract
                    }
                    if(newRoadSign.condition) {
                        params.condition = newRoadSign.condition
                    }
                }
                params.roadsign_ids = roadSignIds
                this.restUpdate(this.roadSignsUrl, params, this.success, this.fail)
            }
        },
        success: function (roadSign) {
            this.roadSignUpdate = roadSign
            this.loading = false
            this.$emit('closeAndUpdate', this.roadSignUpdate)
            this.$emit('showRoadSigns')
        },
        fail: function () {
            this.showAlert(this.$t('common.alert_update_failed'))
            this.loading = false
        },
        setDefaultValues: function (roadSign) {
            roadSign = JSON.parse(JSON.stringify(roadSign))
            if (roadSign.contract && roadSign.contract.id) {
                roadSign.contract = roadSign.contract.id
            } else {
                roadSign.contract = undefined
            }
            if (!roadSign.condition) {
                roadSign.condition = undefined
            }
            if (roadSign.remove) {
                roadSign.remove = true
            } else {
                roadSign.remove = undefined
            }
            return roadSign
        },
        fetchLouhiContracts: function () {
            this.loading = true
            this.contracts = []
            let now = new Date()
            var params = {}
            params.startDate = now.toISOString()
            params.showOnlyLouhiContracts = 1
            this.restFetchParams(this.contractOpenUrl,
                params,
                this.handleContracts)
        },
        handleContracts: function (results) {
            this.loading = false
            if (results.data) {
                this.contracts = results.data
            }
        },
    }
}
</script>

<style scoped>

</style>
